import axios from 'axios';
import { clearSession, getSessionToken, SESSION_EXPIRED_EVENT } from './session';

export const fetchData = async (request) => {
  const { method, endpoint, body } = request;
  const sessiontoken = getSessionToken();
  const requestModel = {
    method,
    url: endpoint,
    data: body
  };
  if (sessiontoken)
    requestModel.headers = {
      sessiontoken: sessiontoken
    };
  try {
    const response = await axios.request(requestModel);
    return response.data;
  } catch (e) {
    const status = e.response?.status;
    // the server refused the session: drop it and let the app (Header) sign the user out
    if (status === 401 && sessiontoken) {
      clearSession();
      window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
    }
    return {
      status,
      statusCode: status,
      errormessage: e.response?.data?.errormessage || e.message,
      data: e.response?.data
    }
  }
};
